import { SearchConditionData, PaginationData, SortTypeData } from "../../types";

export const searchConditionInitData: SearchConditionData = {
  userGroupData: {},
  sourceTypeData: {
    nas: true,
    web: true,
  },
  fileTypeData: {
    pdf: true,
    doc: true,
    xls: true,
    ppt: true,
    txt: true,
  },
  dateTypeData: {
    dateDetailMode: false,
    dateType: "",
    dateValue: "",
    selectedFromDate: new Date(),
    selectedToDate: new Date(),
  },
};

/** ソート初期値 */
export const sortTypeInitData: SortTypeData = {
  item: "",
  order: true,
};

/** ページネーション初期値 */
export const paginationInitData: PaginationData = {
  currentPage: 1,
  totalPage: 0,
  displayCount: 0,
  totalCount: 0,
};
